import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = import.meta.glob('./locales/*.json', { eager: true })
  const messages = {}
  
  Object.entries(locales).forEach(([path, mod]) => {
    const matched = path.match(/\/([A-Za-z0-9-_]+)\.json$/i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = mod.default || mod
    }
  })
  return messages
}

export default new VueI18n({
  locale: import.meta.env.VITE_APP_I18N_LOCALE || 'en',
  fallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
